/**
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business React アプリの DOM エントリーポイント。Faro 初期化後に React ルートをマウントする
 * @graph-connects App [calls] ルートコンポーネントを描画する
 */

// Faro 初期化は他の import より前に実行する
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'ado-task' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
